'use client';

import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';

interface AnimatedIconProps {
  path: string;
}

const dataCache = new Map<string, any>();
const inflight = new Map<string, Promise<any>>();

async function loadJson(path: string) {
  const cached = dataCache.get(path);
  if (cached) return cached;

  const inF = inflight.get(path);
  if (inF) return inF;

  const p = fetch(path)
    .then((r) => {
      if (!r.ok) throw new Error(`Lottie fetch failed: ${r.status}`);
      return r.json();
    })
    .then((json) => {
      dataCache.set(path, json);
      return json;
    })
    .finally(() => inflight.delete(path));

  inflight.set(path, p);
  return p;
}

export default function AnimatedIcon({ path }: AnimatedIconProps) {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    let alive = true;

    loadJson(path)
      .then((json) => {
        if (alive) setAnimationData(json);
      })
      .catch((err) => {
        console.error('Failed to load animation:', err);
        if (alive) setAnimationData(null);
      });

    return () => {
      alive = false;
    };
  }, [path]);

  if (!animationData) {
    return <div className="w-full h-full bg-slate-700 rounded-full animate-pulse" />;
  }

  return <Lottie animationData={animationData} loop />;
}
